const API_BASE_URL = 'https://goback.suv.life'

export async function generateRoutes(params) {
  const response = await fetch(`${API_BASE_URL}/api/generate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  })
  
  if (!response.ok) {
    const error = await response.json()
    throw new Error(error.message || '生成路线失败')
  }
  
  return response.json()
}

export async function getRoute(routeId) {
  const response = await fetch(`${API_BASE_URL}/api/route/${routeId}`)
  
  if (!response.ok) {
    throw new Error('获取路线详情失败')
  }
  
  return response.json()
}

export async function getLatestRoutes() {
  const response = await fetch(`${API_BASE_URL}/api/routes/latest`)
  
  if (!response.ok) {
    throw new Error('获取最新路线失败')
  }
  
  return response.json()
}
